import axios from 'axios';

const API_BASE = 'https://panteramg.com/api';

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
    });

    export const albumsAPI = {
    getAll: () => api.get('/albums'),
    getOne: (id) => api.get(`/albums/${id}`),
    create: (data) => api.post('/albums', data),
    update: (id, data) => api.put(`/albums/${id}`, data),
    delete: (id) => api.delete(`/albums/${id}`),
    };

    export const newsAPI = {
    getAll: () => api.get('/news'),
    getOne: (id) => api.get(`/news/${id}`),
    create: (data) => api.post('/news', data),
    update: (id, data) => api.put(`/news/${id}`, data),
    delete: (id) => api.delete(`/news/${id}`),
    };

    export const filmsAPI = {
    getAll: () => api.get('/films'),
    getOne: (id) => api.get(`/films/${id}`),
    create: (data) => api.post('/films', data),
    update: (id, data) => api.put(`/films/${id}`, data),
    delete: (id) => api.delete(`/films/${id}`),
    };

    export const storyAPI = {
    getAll: () => api.get('/story'),
    getOne: (id) => api.get(`/story/${id}`),
    create: (data) => api.post('/story', data),
    update: (id, data) => api.put(`/story/${id}`, data),
    delete: (id) => api.delete(`/story/${id}`),
    };

    export const merchAPI = {
    getAll: () => api.get('/merch'),
    getOne: (id) => api.get(`/merch/${id}`),
    create: (data) => api.post('/merch', data),
    update: (id, data) => api.put(`/merch/${id}`, data),
    delete: (id) => api.delete(`/merch/${id}`),
};

export default api;